module.exports = __webpack_public_path__ + "img/lightBAML5.5dc463a3.png";